import { getApi, getApiById, postApi, putApi } from "../../Shared/Services/RestService";
import { SubscriptionPlanResponse } from "../Types/SubscriptionPlanType";

export const getAllSubscriptionPlans = () => {
  return getApi<SubscriptionPlanResponse[]>("/subscriptions");
};

export const getSubscriptionPlanById = (id: string ) => {
  return getApiById<SubscriptionPlanResponse | null>("/subscriptions", id);
};

export const createSubscriptionPlan = (payload: any) => {
  return postApi<SubscriptionPlanResponse>("/subscriptions", payload);
};

export const updateSubscriptionPlan = (payload: any, id: string) => {
  return putApi<SubscriptionPlanResponse | null>("/subscriptions", id, payload);
};


